import { GetGameTypeTableData } from '@/modules/game/type'
import { columns } from './constants'
import { SortableTable } from '@/common/ui/table/sortable-table'
import { SortableRow } from './SortableRow'
import { toast } from 'sonner'
import { useQueryClient } from '@tanstack/react-query'
import { GameQueryKeys } from '@/modules/game/keys'
import useMutationUpdateGameType from '@/modules/game/api/hooks/useMutationUpdateGameType'

interface GameTypeTableProps {
	data: GetGameTypeTableData[]
}

export default function GameTypeTable({ data }: GameTypeTableProps) {
	const { mutateAsync: updateGameType } = useMutationUpdateGameType()
	const queryClient = useQueryClient()

	const handleOrderChange = async (
		_newData: GetGameTypeTableData[],
		movedItem: GetGameTypeTableData,
		newIndex: number,
	) => {
		await updateGameType({
			id: movedItem.id,
			payload: {
				order: newIndex + 1,
			},
		})
		queryClient.invalidateQueries({
			queryKey: [GameQueryKeys.GetGameTypeList],
		})
		toast.success('อัพเดทลำดับสำเร็จ')
	}

	return (
		<SortableTable
			data={data}
			columns={columns}
			searchPlaceholder="ค้นหาประเภทเกม"
			onOrderChange={handleOrderChange}
			SortableRowComponent={SortableRow}
			totalItems={data.length}
		/>
	)
}
